import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TuscanyMap = ({ className = '', onProvinceSelect }) => {
  const navigate = useNavigate();
  const [hoveredProvince, setHoveredProvince] = useState(null);

  const provinces = {
    massaCarrara: { name: 'Massa Carrara', link: '/aree-servite/massa-carrara' },
    lucca: { name: 'Lucca', link: '/aree-servite/lucca' },
    pistoia: { name: 'Pistoia', link: '/aree-servite/pistoia' },
    prato: { name: 'Prato', link: '/aree-servite/firenze' },
    firenze: { name: 'Firenze', link: '/aree-servite/firenze' },
    pisa: { name: 'Pisa', link: '/aree-servite/pisa', primary: true },
    livorno: { name: 'Livorno', link: '/aree-servite/livorno' },
    siena: { name: 'Siena', link: '/aree-servite/firenze' },
    arezzo: { name: 'Arezzo', link: '/aree-servite/firenze' },
    grosseto: { name: 'Grosseto', link: '/aree-servite/livorno' }
  };

  const handleClick = (provinceKey) => {
    const province = provinces[provinceKey];
    if (onProvinceSelect) {
      onProvinceSelect(province);
    } else if (province?.link) {
      navigate(province.link);
    }
  };

  const getProvinceColor = (provinceKey) => {
    const province = provinces[provinceKey];
    if (hoveredProvince === provinceKey) {
      return province?.primary ? '#0284c7' : '#38bdf8';
    }
    if (province?.primary) {
      return '#0ea5e9';
    }
    return '#22d3ee';
  };

  return (
    <div className={`relative ${className}`}>
      <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-8">
        {/* Header */}
        <div className="text-center mb-6">
          <h3 className="text-xl font-medium text-gray-900 mb-2">Aree Servite in Toscana</h3>
          <p className="text-sm text-gray-500">Clicca su una provincia per maggiori dettagli</p>
        </div>

        {/* Simple Map Grid */}
        <div className="max-w-xl mx-auto">
          <div className="grid grid-cols-4 gap-2">
            {/* Row 1 */}
            <div></div>
            <button
              onClick={() => handleClick('massaCarrara')}
              onMouseEnter={() => setHoveredProvince('massaCarrara')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-3 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
              style={{ backgroundColor: getProvinceColor('massaCarrara') }}
            >
              <span className="text-white text-xs font-medium block">Massa</span>
              <span className="text-white text-xs font-medium block">Carrara</span>
            </button>
            <button
              onClick={() => handleClick('lucca')}
              onMouseEnter={() => setHoveredProvince('lucca')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-3 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
              style={{ backgroundColor: getProvinceColor('lucca') }}
            >
              <span className="text-white text-sm font-medium">Lucca</span>
            </button>
            <div className="flex gap-1">
              <button
                onClick={() => handleClick('pistoia')}
                onMouseEnter={() => setHoveredProvince('pistoia')}
                onMouseLeave={() => setHoveredProvince(null)}
                className="flex-1 p-2 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
                style={{ backgroundColor: getProvinceColor('pistoia') }}
              >
                <span className="text-white text-xs font-medium">Pistoia</span>
              </button>
              <button
                onClick={() => handleClick('prato')}
                onMouseEnter={() => setHoveredProvince('prato')}
                onMouseLeave={() => setHoveredProvince(null)}
                className="flex-1 p-2 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
                style={{ backgroundColor: getProvinceColor('prato') }}
              >
                <span className="text-white text-xs font-medium">Prato</span>
              </button>
            </div>

            {/* Row 2 */}
            <div></div>
            <button
              onClick={() => handleClick('pisa')}
              onMouseEnter={() => setHoveredProvince('pisa')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-4 rounded-lg text-center transition-all duration-300 hover:shadow-lg ring-2 ring-sky-300 ring-offset-2"
              style={{ backgroundColor: getProvinceColor('pisa') }}
            >
              <span className="text-white text-sm font-bold block">PISA</span>
              <span className="text-white/80 text-xs">Sede</span>
            </button>
            <button
              onClick={() => handleClick('firenze')}
              onMouseEnter={() => setHoveredProvince('firenze')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-4 rounded-lg text-center transition-all duration-300 hover:shadow-lg col-span-2"
              style={{ backgroundColor: getProvinceColor('firenze') }}
            >
              <span className="text-white text-sm font-medium">Firenze</span>
            </button>

            {/* Row 3 */}
            <button
              onClick={() => handleClick('livorno')}
              onMouseEnter={() => setHoveredProvince('livorno')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-3 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
              style={{ backgroundColor: getProvinceColor('livorno') }}
            >
              <span className="text-white text-sm font-medium">Livorno</span>
            </button>
            <div></div>
            <button
              onClick={() => handleClick('siena')}
              onMouseEnter={() => setHoveredProvince('siena')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-3 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
              style={{ backgroundColor: getProvinceColor('siena') }}
            >
              <span className="text-white text-sm font-medium">Siena</span>
            </button>
            <button
              onClick={() => handleClick('arezzo')}
              onMouseEnter={() => setHoveredProvince('arezzo')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-3 rounded-lg text-center transition-all duration-300 hover:shadow-lg"
              style={{ backgroundColor: getProvinceColor('arezzo') }}
            >
              <span className="text-white text-sm font-medium">Arezzo</span>
            </button>

            {/* Row 4 */}
            <div></div>
            <button
              onClick={() => handleClick('grosseto')}
              onMouseEnter={() => setHoveredProvince('grosseto')}
              onMouseLeave={() => setHoveredProvince(null)}
              className="p-4 rounded-lg text-center transition-all duration-300 hover:shadow-lg col-span-2"
              style={{ backgroundColor: getProvinceColor('grosseto') }}
            >
              <span className="text-white text-sm font-medium">Grosseto</span>
            </button>
            <div></div>
          </div>
        </div>

        {/* Tooltip */}
        {hoveredProvince && provinces[hoveredProvince] && (
          <div className="mt-6 text-center animate-fade-in">
            <div className="inline-flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full">
              {provinces[hoveredProvince].primary && (
                <span className="w-2 h-2 rounded-full bg-sky-500"></span>
              )}
              <span className="font-medium text-gray-900">
                {provinces[hoveredProvince].name}
              </span>
              <span className="text-gray-500">→</span>
              <span className="text-sky-500 text-sm">Clicca per dettagli</span>
            </div>
          </div>
        )}

        {/* Legend */}
        <div className="flex flex-wrap justify-center gap-6 mt-8 pt-6 border-t border-gray-100 text-sm">
          <div className="flex items-center gap-2">
            <span className="w-4 h-4 rounded bg-sky-500 ring-2 ring-sky-300 ring-offset-1"></span>
            <span className="text-gray-600">Pisa - Nostra Sede</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-4 h-4 rounded bg-cyan-400"></span>
            <span className="text-gray-600">Province Servite</span>
          </div>
        </div>

        {/* Info */}
        <div className="mt-6 p-4 bg-sky-50 border border-sky-100 rounded-lg text-center">
          <p className="text-sm text-sky-800">
            <strong>💡 Sopralluogo gratuito</strong> nella provincia di Pisa. 
            Per le altre province è richiesto un contributo spese di sopralluogo.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TuscanyMap;
